
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotions/[promotionSlug]",
      function () {
        return require("private-next-pages/promotions/[promotionSlug].tsx");
      }
    ]);
  